import React, {useEffect} from 'react';
import logo from '../../images/logo-ams.jpg'
import './CmTopBar.scss'
import {Alert, AlertTitle, Box, Button, IconButton, Popover, Typography} from "@mui/material";
import Badge, {badgeClasses} from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {styled} from "@mui/material/styles";
import CloseIcon from '@mui/icons-material/Close';
import {CmAlert, CmAlertType} from "./types";
import {Link} from "react-router-dom";
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import {selectShortPathState, setShortPath} from "../../features/auth/authSlice";
import {useDispatch, useSelector} from "react-redux";

const CmTopBar = () => {

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const openAlertsBox = Boolean(anchorEl);
    const id = openAlertsBox ? 'alert-popover' : undefined;
    const shortPath = useSelector(selectShortPathState);
    const [mockAlerts, setMockAlerts] = React.useState<CmAlert[]>([]);
    const dispatch = useDispatch();

    const CartBadge = styled(Badge)`
        & .${badgeClasses.badge} {
            top: -12px;
            right: -6px;
        }
    `;

    useEffect(() => {
            setMockAlerts([
                {
                    title: 'Akceptacja lub odrzucenie kreacji (test)',
                    description: <React.Fragment>
                        <Typography>Kreacja <Link onClick={() => window.location.reload()} to={'/creations/97'}
                                                  className="link">W plenerze dgcs</Link> jest gotowa do weryfikacji
                        </Typography>
                    </React.Fragment>,
                    type: CmAlertType.Info,
                },
                {
                    title: 'Brak nośników w emisji (test)',
                    description: <React.Fragment>
                        <Typography>W emisji <Link onClick={() => window.location.reload()} to={'/creations/116'}
                                                   className="link">test akcpetacji kreacji</Link> brakuje nośników
                        </Typography>
                    </React.Fragment>,
                    type: CmAlertType.Warning,
                },
                {
                    title: 'Niepowodzenie emisji (test)',
                    description: <React.Fragment>
                        <Typography>Emisja <Link onClick={() => window.location.reload()} to={'/creations/116'}
                                                 className="link">test akcpetacji kreacji</Link> zakończona niepowodzeniem
                        </Typography>
                    </React.Fragment>,
                    type: CmAlertType.Error,
                }
            ]);
        }
        , [])

    return (<div className={'CmTopBar'}>
        <div className={'CmTopBar__logo'}>
            <img
                height={'48px'}
                className='CmTopBar__logo--img'
                src={logo}
                alt='logo'
            />
            <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', paddingX: '60px', gap: '10px'}}>
                <Typography sx={{marginRight: '10px'}}>
                    {
                        JSON.parse(localStorage.getItem('user') || "{}").profile && JSON.parse(localStorage.getItem('user') || "{}").profile.email
                    }
                </Typography>

                {/*<IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>*/}
                {/*    <NotificationsIcon fontSize="small"/>*/}
                {/*    <CartBadge badgeContent={mockAlerts.length} color="primary" overlap="circular"/>*/}
                {/*</IconButton>*/}
                {mockAlerts.length > 0 && (<Popover
                    id={id}
                    open={openAlertsBox}
                    anchorEl={anchorEl}
                    onClose={() => {
                        setAnchorEl(null);
                    }}
                    sx={{borderRadius: 2, boxShadow: 2}}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                >
                    <Box sx={{width: '40rem', padding: '10px'}}>
                        {
                            mockAlerts.map((alert, index) => {
                                return (<Alert key={index} severity={alert.type} sx={{marginBottom: '10px'}} action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => {
                                            setMockAlerts([...mockAlerts.filter(el => el !== alert)])
                                        }}
                                    >
                                        <CloseIcon fontSize="inherit"/>
                                    </IconButton>
                                }>

                                    <AlertTitle><strong>{alert.title}</strong></AlertTitle>
                                    {alert.description}

                                </Alert>)
                            })
                        }

                        <Box sx={{display: 'flex', justifyContent: 'center'}}>
                            <Button
                                variant="text"
                                onClick={() => {
                                    setMockAlerts([])
                                }}
                            >
                                Usuń wszystkie wiadomości
                            </Button>
                        </Box>

                    </Box>
                </Popover>)}
            </Box>
        </div>
    </div>)
}

export default CmTopBar;